import { Controller } from "@hotwired/stimulus"

const SCOPE_ICONS = {
  auto:       "bi-stars",
  all:        "bi-grid",
  task:       "bi-list-task",
  person:     "bi-people",
  building:   "bi-building",
  ai:         "bi-cpu",
  drive:      "bi-folder2",
  management: "bi-tools",
  email:      "bi-envelope",
  type:       "bi-tag",
}

// Manages the icon-enabled search scope dropdown in the global search bar.
// Replaces the native <select> with a Bootstrap dropdown so each option
// can display a Bootstrap Icon alongside its label.
export default class extends Controller {
  static targets = ["button", "icon", "label", "input"]
  static values  = { selected: String }

  connect() {
    const initial = this.inputTarget.value || "auto"
    this._applySelection(initial)
  }

  select(event) {
    event.preventDefault()
    const value = event.currentTarget.dataset.value
    this._applySelection(value)

    // Close the Bootstrap dropdown
    const dropdownEl = this.element.querySelector("[data-bs-toggle='dropdown']")
    const bsDropdown = window.bootstrap?.Dropdown.getInstance(dropdownEl)
    bsDropdown?.hide()
  }

  _applySelection(value) {
    this.inputTarget.value = value

    const icon  = SCOPE_ICONS[value] || "bi-grid"
    const labelEl = this.element.querySelector(`[data-value="${value}"] .scope-label`)
    const label = labelEl?.textContent?.trim() || value

    this.iconTarget.className    = `bi ${icon}`
    this.labelTarget.textContent = label

    // Highlight active item
    this.element.querySelectorAll(".dropdown-item").forEach(el => {
      el.classList.toggle("active", el.dataset.value === value)
    })
  }
}
